<script>
	export let title = "";
	export let problem = "";
	export let solution = "";
	export let benefits = [];
</script>

<div
	class="group bg-[#13131f] rounded-2xl p-8 border border-white/5 hover:border-primary/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(124,58,237,0.1)]"
>
	<h3
		class="text-2xl font-bold text-white mb-6 group-hover:text-primary-300 transition-colors"
	>
		{title}
	</h3>

	<div class="mb-6">
		<p
			class="text-xs text-gray-500 uppercase font-mono tracking-widest mb-2"
		>
			Challenge
		</p>
		<p class="text-gray-400 leading-relaxed">{problem}</p>
	</div>

	<div class="mb-6">
		<p
			class="text-xs text-primary-400 uppercase font-mono tracking-widest mb-2"
		>
			OS Studio Solution
		</p>
		<p class="text-white font-medium text-lg">{solution}</p>
	</div>

	<div>
		<p
			class="text-xs text-gray-500 uppercase font-mono tracking-widest mb-3"
		>
			Key Benefits
		</p>
		<ul class="space-y-3">
			{#each benefits as benefit}
				<li class="flex items-start">
					<span class="text-primary mr-3 font-bold mt-0.5">→</span>
					<span class="text-gray-300">{benefit}</span>
				</li>
			{/each}
		</ul>
	</div>
</div>
